import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import IosShareIcon from '@mui/icons-material/IosShare';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { hasInstallPrompt, isIOS, isRunningAsPWA, setPWAInstallContext, showInstallPrompt } from '../../utils/pwa-utils';
import css from './SchoolPWAInstallBanner.module.css';

const DISMISSED_KEY = 'school-pwa-banner-dismissed';

export default function SchoolPWAInstallBanner() {
  const [available, setAvailable] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISSED_KEY) === '1');
  const ios = isIOS();

  useEffect(() => {
    if (isRunningAsPWA()) return undefined;
    setPWAInstallContext('school');
    setAvailable(hasInstallPrompt());
    const handleAvailable = () => setAvailable(true);
    window.addEventListener('pwaInstallAvailable', handleAvailable);
    return () => window.removeEventListener('pwaInstallAvailable', handleAvailable);
  }, []);

  if (isRunningAsPWA() || dismissed || (!ios && !available)) return null;

  const close = () => {
    sessionStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  const install = async () => {
    setPWAInstallContext('school');
    await showInstallPrompt();
    // The browser prompt can only be answered once, win or lose - hide the button either way.
    setAvailable(false);
  };

  return (
    <aside className={css.banner} aria-label="Install Bubble Ai Schools">
      <div className={css.icon}><GetAppIcon /></div>
      <div className={css.copy}>
        <div className={css.heading}>Take Bubble Ai Schools with you</div>
        {ios ? (
          <div className={css.instructions}>
            <span><IosShareIcon /> Tap <strong>Share</strong></span>
            <span><AddBoxOutlinedIcon /> Choose <strong>Add to Home Screen</strong></span>
            <span>Tap <strong>Add</strong> to finish</span>
          </div>
        ) : (
          <div className={css.description}>Install the Schools app for quick access to your school dashboard.</div>
        )}
      </div>
      {!ios && <button type="button" className={css.installButton} onClick={install}><GetAppIcon /> Install</button>}
      <button type="button" className={css.closeButton} onClick={close} aria-label="Dismiss school app banner"><CloseIcon /></button>
    </aside>
  );
}